import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

import { isDefiniteDeadEndSelector } from '../selectors/isDefiniteDeadEndSelector'

export function useIsDefiniteDeadEnd(dialogId: string) {
  //@ts-ignored
  return useSelector<RootState, boolean>(state => isDefiniteDeadEndSelector(state, dialogId))
}
